<template>
  <div class="w-full flex flex-row">
    <div class="flex flex-col h-full w-full">
      <contacts-header
        ref="contactsHeader"
        :search-query="searchQuery"
        :header-title="pageTitle"
        :segments-id="segmentsId"
        this-selected-contact-id=""
        @on-input-search="onInputSearch"
        @on-create-filter="onCreateFilter"
        @on-toggle-create="onToggleCreate"
        @on-toggle-filter="onToggleFilters"
        @on-search-submit="onSearchSubmit"
        @on-toggle-import="onToggleImport"
        @on-export-submit="onExportSubmit"
        @on-toggle-report="onToggleReport"
        @on-toggle-save-filter="onToggleSaveFilters"
        @on-toggle-delete-filter="onToggleDeleteFilters"
        @on-toggle-edit-filter="onToggleFilters"
        @on-state-search="onStateSearch"
        @on-status-search="onStatusSearch"
        @on-column-config-change="onColumnConfigChange"
      />
      <!-- Bulk Actions Panel -->
      <contact-bulk-actions
        v-if="selectedContacts.length > 0"
        :contacts="selectedContactsData"
        :all-contacts-selected="allContactsOnPageSelected"
        @select-all-contacts="onSelectAllContacts"
        @assign-agent="onAssignAgentBulk"
        @assign-labels="onAssignLabelsBulk"
        @update-status="onUpdateStatusBulk"
      />
      <contacts-table
        ref="contactsTable"
        :contacts="records"
        :show-search-empty-state="showEmptySearchResult"
        :is-loading="uiFlags.isFetching"
        :on-click-contact="openContactInfoPanel"
        :active-contact-id="selectedContactId"
        :sort-param="currentSortParam"
        :sort-order="currentSortOrder"
        :visible-columns="columnConfig.visibleColumns"
        :column-order="columnConfig.columnOrder"
        :selected-contacts="selectedContacts"
        @on-sort-change="onSortChange"
        @contact-deleted="onContactDeleted"
        @select-contact="onSelectContact"
        @deselect-contact="onDeselectContact"
        @select-all-contacts="onSelectAllContactsFromTable"
        @deselect-all-contacts="onDeselectAllContacts"
      />
      <table-footer
        :current-page="Number(meta.currentPage)"
        :total-count="meta.count"
        :page-size="20"
        @page-change="onPageChange"
      />
    </div>

    <add-custom-views
      v-if="showAddSegmentsModal"
      :custom-views-query="segmentsQuery"
      :filter-type="filterType"
      :open-last-saved-item="openSavedItemInSegment"
      @close="onCloseAddSegmentsModal"
    />
    <delete-custom-views
      v-if="showDeleteSegmentsModal"
      :show-delete-popup.sync="showDeleteSegmentsModal"
      :active-custom-view="activeSegment"
      :custom-views-id="segmentsId"
      :active-filter-type="filterType"
      :open-last-item-after-delete="openLastItemAfterDeleteInSegment"
      @close="onCloseDeleteSegmentsModal"
    />
    <div
      v-if="showContactViewPane"
      class="modal-overlay-v1"
      @click.stop="closeContactInfoPanel"
    ></div>
    <contact-info-panel
      v-if="showContactViewPane"
      :contact="Contact"
      :on-close="closeContactInfoPanel"
      :is-modal-view="true"
      @contact-deleted="onContactDeleted"
    />
    <create-filter
      :show="showCreateFilter"
      @cancel="onCreateFilter"
      v-on-clickaway="hideFilter"
    />
    <!-- <create-contact :show="showCreateModal" @cancel="onToggleCreate" /> -->
    <div>
      <new-create-contact :show="showCreateModal" @cancel="onToggleCreate" />
    </div>

    <woot-modal :show.sync="showImportModal" :on-close="onToggleImport">
      <import-contacts v-if="showImportModal" :on-close="onToggleImport" />
    </woot-modal>
    <send-report v-if="showReportModal" :show="showReportModal" @close="onToggleReport" />
    <div class="contacts-advanced-filters-modal-host">
      <woot-modal
        :show.sync="showFiltersModal"
        :on-close="closeAdvanceFiltersModal"
        size="medium"
      >
        <contacts-advanced-filters
          v-if="showFiltersModal"
          :on-close="closeAdvanceFiltersModal"
          :initial-filter-types="contactFilterItems"
          :initial-action-types="contactActionsItems"
          :initial-applied-filters="appliedFilter"
          :initial-applied-actions="appliedActions"
          :leads="lastactivity"
          :active-segment-name="activeSegmentName"
          :is-segments-view="hasActiveSegments"
          :states-for-filter="contactStates"
          @applyFilter="onApplyFilter"
          @updateSegment="onUpdateSegment"
          @clearFilters="clearFilters"
        />
      </woot-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateFilter from '../../conversation/contact/CreateFilter.vue';
import NewCreateContact from '../../conversation/contact/NewCreateContact.vue';
import ContactsHeader from './Header';
import ContactsTable from './ContactsTableVueTables2'; // Using vue-tables-2 instead of ve-table
import ContactInfoPanel from './ContactInfoPanel';
import CreateContact from 'dashboard/routes/dashboard/conversation/contact/CreateContact';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import ImportContacts from './ImportContacts.vue';
import SendReport from './SendReport.vue';
import ContactsAdvancedFilters from './ContactsAdvancedFilters.vue';
import ContactBulkActions from 'dashboard/components/widgets/contactBulkActions/Index.vue';
import contactFilterItems from '../contactFilterItems';
import contactActionsItems from "../contactActions"
import filterQueryGenerator from '../../../../helper/filterQueryGenerator';
import AddCustomViews from 'dashboard/routes/dashboard/customviews/AddCustomViews';
import DeleteCustomViews from 'dashboard/routes/dashboard/customviews/DeleteCustomViews';
import { CONTACTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import alertMixin from 'shared/mixins/alertMixin';
import countries from 'shared/constants/countries.js';
import { generateValuesForEditCustomViews } from 'dashboard/helper/customViewsHelper';
import { mixin as clickaway } from 'vue-clickaway';
import types from '../../../../store/mutation-types';
import axios from 'axios';

const DEFAULT_PAGE = 1;
const FILTER_TYPE_CONTACT = 1;

export default {
  components: {
    ContactsHeader,
    ContactsTable,
    TableFooter,
    ContactInfoPanel,
    CreateContact,
    ImportContacts,
    SendReport,
    ContactsAdvancedFilters,
    ContactBulkActions,
    AddCustomViews,
    DeleteCustomViews,
    CreateFilter,
    NewCreateContact,
  },
  mixins: [alertMixin, clickaway],
  props: {
    label: { type: String, default: '' },
    segmentsId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      searchQuery: '',
      showCreateModal: false,
      showImportModal: false,
      showReportModal: false,
      showCreateFilter: false,
      selectedContactId: '',
      // Default sort: created_at desc, but the underlying scope on the API
      // side coalesces with reengaged_at, so duplicate Facebook leads bubble
      // to the top while the UI sort indicator stays on "Created At".
      sortConfig: { created_at: 'desc' },
      showFiltersModal: false,
      contactFilterItems: contactFilterItems.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      contactActionsItems: contactActionsItems.map(filter =>({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      segmentsQuery: {},
      filterType: FILTER_TYPE_CONTACT,
      showAddSegmentsModal: false,
      showDeleteSegmentsModal: false,
      appliedFilter: [],
      appliedActions:[],
      status_id: null,
      state_id: null,
      columnConfig: {
        visibleColumns: [],
        columnOrder: [],
      },
      // Bulk action selection state
      selectedContacts: [],
      /** Account states (CRM) for advanced filter / segment edit UI */
      contactStates: [],
    };
  },
  beforeDestroy() {
    bus.$off('state-search', this.onStateSearch);
    bus.$off('status-search', this.onStatusSearch);
    bus.$off('on-apply-filter-submit', this.onApplyFilter);
    bus.$off('on-assign-agent',this.submitFilterQueries);
    // bus.$off('input-search', this.onInputSearch);
  },
  computed: {
    ...mapGetters({
      records: 'contacts/getContacts',
      uiFlags: 'contacts/getUIFlags',
      meta: 'contacts/getMeta',
      segments: 'customViews/getCustomViews',
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
      agentList: 'agents/getAgents',
      labels: 'labels/getLabels',
      campaigns: 'campaigns/getAllCampaigns',
      boards: 'boards/getBoards',
      getContact: 'contacts/getContact',  // ← ADD THIS
    }),
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.records.length === 0;
      return hasEmptyResults;
    },
    currentSortParam() {
      return Object.keys(this.sortConfig)[0] || 'created_at';
    },
    currentSortOrder() {
      return Object.values(this.sortConfig)[0] || 'desc';
    },
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
    hasActiveSegments() {
      return this.activeSegment && this.segmentsId !== 0;
    },
    isContactAndLabelDashboard() {
      return (
        this.$route.name === 'contacts_dashboard' ||
        this.$route.name === 'contacts_labels_dashboard'
      );
    },
    pageTitle() {
      if (this.hasActiveSegments) {
        return this.activeSegment.name;
      }
      if (this.label) {
        return `#${this.label}`;
      }
      return this.$t('CONTACTS_PAGE.HEADER');
    },
    lastactivity() {
      return [
        { id: 1, name: 'User' },
        { id: 2, name: 'Agent' },
      ];
    },

    Contact() {
      if (this.selectedContactId) {
        const contact = this.getContact(this.selectedContactId);
        return contact && contact.id ? contact : null;
      }
      return null;
    },
    showContactViewPane() {
      // Only show modal when we have BOTH the ID and the loaded contact data
      return this.selectedContactId !== '' && this.Contact && this.Contact.id;
    },
    wrapClass() {
      return this.showContactViewPane ? 'w-[75%]' : 'w-full';
    },
    pageParameter() {
      // console.log("Full route:", this.$route.fullPath);
      //  console.log("Query parameters:", this.$route.query);
      //  console.log("Page parameter (raw):", this.$route.query.page);
      const selectedPageNumber = Number(this.$route.query?.page);
      // console.log("selectedPageNumber",selectedPageNumber)
      return !Number.isNaN(selectedPageNumber) &&
        selectedPageNumber >= DEFAULT_PAGE
        ? selectedPageNumber
        : DEFAULT_PAGE;
    },
    activeSegment() {
      if (
        this.segmentsId === null ||
        this.segmentsId === undefined ||
        this.segmentsId === '' ||
        String(this.segmentsId) === '0'
      ) {
        return undefined;
      }
      const sid = Number(this.segmentsId);
      const [match] = this.segments.filter(
        view => Number(view.id) === sid
      );
      return match;
    },
    activeSegmentName() {
      return this.activeSegment?.name;
    },
    contactFilters() {
      return this.$store.getters['contacts/getContactFilters'];
    },
    // Bulk action computed properties
    selectedContactsData() {
      return this.records.filter(contact => this.selectedContacts.includes(contact.id));
    },
    allContactsOnPageSelected() {
      return this.records.length > 0 && this.selectedContacts.length === this.records.length;
    },
  },
  watch: {
    // label() {
    //   this.fetchContacts(DEFAULT_PAGE);
    //   if (this.hasAppliedFilters) {
    //     this.clearFilters();
    //   }
    // },

    //  meta: {
    //     handler(newMeta) {
    //      console.log('Meta updated:', newMeta);
    //    },
    //  deep: true
    // },

    $route: {
      handler(to, from) {
        // Clear selections when page changes
        this.selectedContacts = [];

        const isSegmentRoute =
          to.name === 'contacts_segments_dashboard' &&
          to.params.id != null &&
          String(to.params.id) !== '0' &&
          String(to.params.id) !== '';

        const enteredOrSwitchedSegment =
          isSegmentRoute &&
          (from.name !== 'contacts_segments_dashboard' ||
            String(to.params.id) !== String(from.params.id));

        if (enteredOrSwitchedSegment) {
          this.beginSegmentContactsLoad();
        }

        const url = new URL(window.location.href);
        const pageParam = url.searchParams.get('page');
        const selectedPageNumber = Number(pageParam) || DEFAULT_PAGE;

        if (selectedPageNumber >= 1 && !this.hasAppliedFilters) {
          if (this.$route.name === 'contacts_segments_dashboard') {
            if (this.hasActiveSegments) {
              this.fetchSavedFilteredContact(
                this.activeSegment.query,
                selectedPageNumber,
                this.searchQuery
              );
            }
            return;
          }
          this.fetchContacts(selectedPageNumber);
        }
      },
      // Don't use immediate: true — initial load is handled by mounted (onSortChange → submitFilterQueries → fetchContacts).
      // This avoids double fetch on load; watcher still runs when route actually changes (e.g. back/forward, link).
    },

    // Also watch records to debug data updates
    records: {
      handler(newRecords) {
        const url = new URL(window.location.href);
        const currentUrlPage = url.searchParams.get('page') || DEFAULT_PAGE;

        // console.log('Records updated:', {
        //   count: newRecords.length,
        //   urlPage: currentUrlPage,
        //   metaPage: this.meta.currentPage,
        //   currentUrl: window.location.href
        // });
      },
      deep: true,
    },

    activeSegment(newVal, oldVal) {
      // Skip initial run when there is no segment to avoid duplicate fetch (mounted already triggers via submitFilterQueries)
      if (newVal === undefined && oldVal === undefined) return;
      if (this.hasActiveSegments) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, DEFAULT_PAGE, this.searchQuery);
      } else if (this.hasAppliedFilters && this.$route.name === 'contacts_dashboard') {
        this.fetchFilteredContacts(DEFAULT_PAGE);
      } else if (this.$route.name === 'contacts_segments_dashboard') {
        // Avoid loading full contacts list while on segment route (stale vuex otherwise).
        return;
      } else {
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
  },
  beforeMount() {
    if (
      this.$route.name === 'contacts_segments_dashboard' &&
      String(this.segmentsId) !== '0' &&
      this.segmentsId != null &&
      this.segmentsId !== ''
    ) {
      this.beginSegmentContactsLoad();
    }
  },
  async mounted() {
    if (
      this.$route.name === 'contacts_segments_dashboard' &&
      String(this.segmentsId) !== '0' &&
      this.segmentsId != null &&
      this.segmentsId !== ''
    ) {
      await this.$store.dispatch('customViews/get', 'contact');
    }
    this.onSortChange({ created_at: 'desc' });
    // Initial load: submitFilterQueries (from onSortChange) fetches contacts or applies filter — no duplicate fetch here
    bus.$on('on-assign', this.onAssign);
    bus.$on('on-apply-filter-submit', this.onApplyFilter);
    bus.$on('on-assign-agent',this.submitFilterQueries);
    // Page URL is synced by fetchContacts / onApplyFilter / submitFilterQueries — avoid overwriting a page-1 reset here
    // this.clearFilters();
    if (this.contactFilters && this.contactFilters.length > 0) {
      this.onApplyFilter(this.contactFilters);
    }
    
    // Fetch required data for segment editing
    this.$store.dispatch('agents/get');
    this.$store.dispatch('labels/get');
    this.$store.dispatch('boards/get');
    this.$store.dispatch('attributes/get');
    // Fetch campaign filter options and set filter attributes
    await this.$store.dispatch('campaigns/fetchCampaignFilterOptions');
    await this.fetchContactStatesForFilters();
  },
  methods: {
    async fetchContactStatesForFilters() {
      const accountId = this.$route.params.accountId;
      if (accountId == null || String(accountId).trim() === '') {
        this.contactStates = [];
        return;
      }
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${accountId}/states`,
          { params: { only_data: 'true' } }
        );
        const rows = data.states_data || [];
        this.contactStates = rows
          .filter(s => s && s.id != null)
          .map(s => ({ id: s.id, name: s.name }));
      } catch {
        this.contactStates = [];
      }
    },
    /**
     * Drop stale list from the previous route (e.g. main contacts) so the segment
     * view shows the loader first, then segment results — not a flash of all contacts.
     */
    beginSegmentContactsLoad() {
      this.$store.commit(`contacts/${types.CLEAR_CONTACTS}`);
      this.$store.commit(`contacts/${types.SET_CONTACT_META}`, {
        count: 0,
        current_page: 1,
      });
      this.$store.commit(`contacts/${types.SET_CONTACT_UI_FLAG}`, {
        isFetching: true,
      });
    },
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    getSortAttribute() {
      let sortAttr = Object.keys(this.sortConfig).reduce((acc, sortKey) => {
        const sortOrder = this.sortConfig[sortKey];
        if (sortOrder) {
          const sortOrderSign = sortOrder === 'asc' ? '' : '-';
          return `${sortOrderSign}${sortKey}`;
        }
        return acc;
      }, '');
      if (!sortAttr) {
        this.sortConfig = { last_activity_at: 'desc' };
        sortAttr = '-last_activity_at';
      }
      return sortAttr;
    },

    fetchContacts(page) {
      if (this.isContactAndLabelDashboard) {
        this.$store.commit('contacts/SET_CONTACT_META', { current_page: page });
        this.updatePageParam(page);
        let value = '';
        if (this.searchQuery.charAt(0) === '+') {
          value = this.searchQuery.substring(1);
        } else {
          value = this.searchQuery;
        }

        const requestParams = {
          page,
          sortAttr: this.getSortAttribute(),
          label: this.label,
          ...(this.status_id ? { status_id: this.status_id } : {}),
          ...(this.state_id ? { state_id: this.state_id } : {}),
          ...(this.getAppliedContactFilters?.length > 0 ? { filters: this.getAppliedContactFilters } : {}),

        };

        if (!value && !this.status_id && !this.state_id) {
          this.$store.dispatch('contacts/get', requestParams);
        } else if (this.status_id || this.state_id) {
          this.$store.dispatch('contacts/search', {
            search: encodeURIComponent(value),
            ...requestParams,
          });
        } else if (value) {
          this.$store.dispatch('contacts/search', {
            search: encodeURIComponent(value),
            ...requestParams,
          });
        }
      }
    },

    fetchSavedFilteredContact(payload, page, search = '') {
      if (this.hasActiveSegments) {
        this.updatePageParam(page);
        let value = '';
        if (search && typeof search === 'string') {
          value = search.charAt(0) === '+' ? search.substring(1) : search;
        }
        this.$store.dispatch('contacts/filter', {
          queryPayload: payload,
          page,
          sortAttr: this.getSortAttribute(),
          search: value ? encodeURIComponent(value) : '',
        });
      }
    },
    fetchFilteredContacts(page) {
      if (this.hasAppliedFilters) {
        const payload = this.segmentsQuery;
        this.updatePageParam(page);
        this.$store.dispatch('contacts/filter', {
          queryPayload: payload,
          page,
          sortAttr: this.getSortAttribute(),
        });
      }
    },

    onInputSearch(event) {
      const newQuery = event.target.value;
      const refetchAllContacts = !!this.searchQuery && newQuery === '';
      this.searchQuery = newQuery;
      if (refetchAllContacts) {
        if (this.hasActiveSegments) {
          const payload = this.activeSegment?.query;
          this.fetchSavedFilteredContact(payload, DEFAULT_PAGE, newQuery);
        } else {
          this.fetchContacts(DEFAULT_PAGE);
        }
      }
    },
    onSearchSubmit() {
      this.selectedContactId = '';
      if (this.searchQuery) {
        if (this.hasActiveSegments) {
          const payload = this.activeSegment?.query;
          this.fetchSavedFilteredContact(payload, DEFAULT_PAGE, this.searchQuery);
        } else {
          this.fetchContacts(DEFAULT_PAGE);
        }
      }
    },
    onPageChange(page) {
      this.updatePageParam(page);
      this.$router.push({
        path: this.$route.path, // Keep the current path
        query: { ...this.$route.query, page: page }, // Keep all other queries, update page
      });
      this.selectedContactId = '';
      if (this.segmentsId !== 0) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, page, this.searchQuery);
      } else if (this.hasAppliedFilters) {
        this.fetchFilteredContacts(page);
      } else {
        this.fetchContacts(page);
      }
    },
    openContactInfoPanel(contactId) {
      this.selectedContactId = contactId;
    },
    closeContactInfoPanel() {
      this.selectedContactId = '';
    },
    onToggleCreate() {
      this.showCreateModal = !this.showCreateModal;
    },
    onToggleSaveFilters() {
      this.showAddSegmentsModal = true;
    },
    onCloseAddSegmentsModal() {
      this.showAddSegmentsModal = false;
    },
    onToggleDeleteFilters() {
      this.showDeleteSegmentsModal = true;
    },
    onCloseDeleteSegmentsModal() {
      this.showDeleteSegmentsModal = false;
    },
    onToggleImport() {
      this.showImportModal = !this.showImportModal;
    },
    onToggleReport() {
      this.showReportModal = !this.showReportModal;
    },
    onSortChange(params) {
      this.sortConfig = params;
      // this.fetchContacts(this.meta.currentPage);
      this.submitFilterQueries({ resetToFirstPage: true });

      const sortBy =
        Object.entries(params).find(pair => Boolean(pair[1])) || [];

      this.$track(CONTACTS_EVENTS.APPLY_SORT, {
        appliedOn: sortBy[0],
        order: sortBy[1],
      });
    },
    async onToggleFilters() {
      if (this.hasActiveSegments) {
        // Ensure agents, labels, campaigns, and boards are loaded before initializing segment
        await Promise.all([
          this.$store.dispatch('agents/get'),
          this.$store.dispatch('labels/get'),
          this.$store.dispatch('boards/get'),
          this.$store.dispatch('campaigns/fetchCampaignFilterOptions'),
        ]);
        this.initializeSegmentToFilterModal(this.activeSegment);
      }
      this.showFiltersModal = true;
    },
    closeAdvanceFiltersModal() {
      this.showFiltersModal = false;
      this.appliedFilter = [];
    },


    submitFilterQueries(options = {}) {
      const resetToFirstPage = Boolean(options.resetToFirstPage);
      let newFilter = [...this.getAppliedContactFilters];

      if (newFilter.length === 0) {
        if (this.$route.name === 'contacts_segments_dashboard') {
          if (this.hasActiveSegments) {
            this.fetchSavedFilteredContact(
              this.activeSegment.query,
              this.pageParameter,
              this.searchQuery
            );
          }
          return;
        }
        this.fetchContacts(this.pageParameter);
        return;
      }
      const page = resetToFirstPage ? DEFAULT_PAGE : this.pageParameter;
      if (resetToFirstPage) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, page: DEFAULT_PAGE },
        });
        this.updatePageParam(DEFAULT_PAGE);
      }
      this.segmentsQuery = filterQueryGenerator(newFilter);
      this.$store.dispatch('contacts/filter', {
        queryPayload: this.segmentsQuery,
        page,
        sortAttr: this.getSortAttribute(),
      });
      this.showFiltersModal = false;
    },
    syncContactsListPageInUrl(page) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, page },
      });
      this.updatePageParam(page);
    },
    onApplyFilter(payload) {
      this.closeContactInfoPanel();
      this.segmentsQuery = filterQueryGenerator(payload.filters);
      const page = DEFAULT_PAGE;
      const sortAttr = this.getSortAttribute();

      this.syncContactsListPageInUrl(page);

      this.$store
        .dispatch('contacts/filter', {
          queryPayload: filterQueryGenerator(payload.filters),
          actions: payload.actions,
          isActions: payload.isActions,
          page,
          sortAttr,
        })
        .then(() => {
          if (payload.isActions) {
            setTimeout(() => {
              this.$store.dispatch('contacts/filter', {
                queryPayload: this.segmentsQuery,
                page,
                sortAttr: this.getSortAttribute(),
                isRefetchAfterAction: true,
              });
            }, 2500);
          }
        });
      this.showFiltersModal = false;
    },
    onUpdateSegment(payload, segmentName) {
      const payloadData = {
        ...this.activeSegment,
        name: segmentName,
        query: filterQueryGenerator(payload),
      };
      this.$store.dispatch('customViews/update', payloadData);
      this.closeAdvanceFiltersModal();
    },
    clearFilters() {
      this.$store.dispatch('contacts/clearContactFilters');
      this.fetchContacts(this.pageParameter);
    },
    onExportSubmit() {
      try {
        const q = this.searchQuery || '';
        const filters = this.resolveExportFilters();
        this.$store.dispatch('contacts/export', { q, filters });
        this.showAlert(this.$t('EXPORT_CONTACTS.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('EXPORT_CONTACTS.ERROR_MESSAGE')
        );
      }
    },
    resolveExportFilters() {
      if (this.hasActiveSegments && this.activeSegment?.query) {
        return this.normalizeFilterQuery(this.activeSegment.query);
      }
      if (this.segmentsQuery?.payload?.length) {
        return this.segmentsQuery;
      }
      if (this.hasAppliedFilters) {
        return filterQueryGenerator(this.getAppliedContactFilters);
      }
      return null;
    },
    normalizeFilterQuery(query) {
      if (!query) return null;
      if (Array.isArray(query.payload) && query.payload.length) {
        return query;
      }
      if (Array.isArray(query) && query.length) {
        return { payload: query };
      }
      return null;
    },
    setParamsForEditSegmentModal() {
      // Here we are setting the params for edit segment modal to show the existing values.

      // For agent, labels, campaigns, and boards we get only the id's from the query.
      // So we are mapping the id's to the actual values.

      // For custom attributes we get only attribute key.
      // So we are mapping it to find the input type of the attribute to show in the edit segment modal.
      const params = {
        agents: this.agentList,
        states: this.contactStates,
        labels: this.labels.map(label => ({ id: label.id, name: label.title })),
        campaigns: this.campaigns,
        boards: this.boards,
        countries: countries,
        filterTypes: contactFilterItems,
        allCustomAttributes:
          this.$store.getters['attributes/getAttributesByModel'](
            'contact_attribute'
          ),
      };
      return params;
    },
    initializeSegmentToFilterModal(activeSegment) {
      const query = activeSegment?.query?.payload;
      if (!Array.isArray(query)) return;

      this.appliedFilter.push(
        ...query.map(filter => {
          const params = this.setParamsForEditSegmentModal();
          let values = [];
          
          // Handle date/datetime values - preserve as strings
          if (filter.attribute_key === 'created_at' || filter.attribute_key === 'last_activity_at') {
            // For date filters with 'between' operator, keep as array; otherwise extract first value
            if (filter.filter_operator === 'between') {
              values = filter.values;
            } else if (Array.isArray(filter.values)) {
              // For single date operators (is_greater_than, is_lesser_than, etc.), use the first value
              values = filter.values[0] || '';
            } else {
              values = filter.values;
            }
          } else if (Array.isArray(filter.values)) {
            values = generateValuesForEditCustomViews(filter, params);
          }

          return {
            attribute_key: filter.attribute_key,
            attribute_model: filter.attribute_model,
            filter_operator: filter.filter_operator,
            values: values,
            query_operator: filter.query_operator,
            custom_attribute_type: filter.custom_attribute_type,
            // Preserve statusValues from saved filter for board_id and campaign_id
            statusValues: filter.statusValues || null,
          };
        })
      );
    },
    openSavedItemInSegment() {
      const lastItemInSegments = this.segments[this.segments.length - 1];
      const lastItemId = lastItemInSegments.id;
      this.$router.push({
        name: 'contacts_segments_dashboard',
        params: { id: lastItemId },
      });
    },
    openLastItemAfterDeleteInSegment() {
      if (this.segments.length > 0) {
        this.openSavedItemInSegment();
      } else {
        this.$router.push({ name: 'contacts_dashboard' });
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
    onCreateFilter() {
      this.showCreateFilter = !this.showCreateFilter;
    },
    hideFilter() {
      this.showCreateFilter = false;
    },
    onAssign() {
      const currentPage = this.pageParameter;
      // Handle segments view
      if (this.segmentsId !== 0 && this.activeSegment) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, currentPage, this.searchQuery);
      } else if (this.hasAppliedFilters) {
        // Handle applied filters - use getAppliedContactFilters from store
        this.$store.dispatch('contacts/filter', {
          queryPayload: filterQueryGenerator(this.getAppliedContactFilters),
          page: currentPage,
          sortAttr: this.getSortAttribute(),
        });
      } else {
        this.fetchContacts(currentPage);
      }
    },
    onStateSearch(id) {
      this.state_id = id;
      this.fetchContacts(this.pageParameter);
    },
    onStatusSearch(id) {
      this.status_id = id;
      this.fetchContacts(this.pageParameter);
    },
    onContactDeleted() {
      this.selectedContactId = '';
      const currentPage = this.meta.currentPage || 1;
      const pageSize = 15;

      let pageToFetch = currentPage;
      if (this.records.length === 0 && currentPage > 1) {
        pageToFetch = currentPage - 1;
        this.$router.push({
          path: this.$route.path,
          query: { ...this.$route.query, page: pageToFetch },
        });
      }

      // Handle segments view
      if (this.segmentsId !== 0 && this.activeSegment) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, pageToFetch, this.searchQuery);
      } else if (this.hasAppliedFilters) {
        // Handle applied filters - use getAppliedContactFilters from store
        this.$store.dispatch('contacts/filter', {
          queryPayload: filterQueryGenerator(this.getAppliedContactFilters),
          page: pageToFetch,
          sortAttr: this.getSortAttribute(),
        });
      } else {
        // Fetch regular contacts
        this.fetchContacts(pageToFetch);
      }
    },
    onColumnConfigChange(config) {
      this.columnConfig = config;
    },
    // Bulk action methods - Selection handlers
    onSelectContact(contactId) {
      if (!this.selectedContacts.includes(contactId)) {
        this.selectedContacts.push(contactId);
      }
    },
    onDeselectContact(contactId) {
      this.selectedContacts = this.selectedContacts.filter(id => id !== contactId);
    },
    onSelectAllContactsFromTable(contactIds) {
      this.selectedContacts = [...contactIds];
    },
    onDeselectAllContacts() {
      this.selectedContacts = [];
    },
    onSelectAllContacts(checked) {
      if (checked) {
        this.selectedContacts = this.records.map(contact => contact.id);
      } else {
        this.selectedContacts = [];
      }
    },
    // Bulk action handlers
    async onAssignAgentBulk(agent) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Contact',
          ids: this.selectedContacts,
          fields: {
            assignee_id: agent.id,
          },
        });
        this.selectedContacts = [];
        if (agent.id) {
          this.showAlert(this.$t('BULK_ACTION.CONTACT_ASSIGN_SUCCESFUL'));
        } else {
          this.showAlert(this.$t('BULK_ACTION.CONTACT_UNASSIGN_SUCCESFUL'));
        }
        // Refresh contacts after bulk action
        this.refreshContactsAfterBulkAction();
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.CONTACT_ASSIGN_FAILED'));
      }
    },
    async onAssignLabelsBulk(labels) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Contact',
          ids: this.selectedContacts,
          labels: {
            add: labels,
          },
        });
        this.selectedContacts = [];
        this.showAlert(this.$t('BULK_ACTION.LABELS.ASSIGN_SUCCESFUL'));
        // Refresh contacts after bulk action
        this.refreshContactsAfterBulkAction();
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.LABELS.ASSIGN_FAILED'));
      }
    },
    async onUpdateStatusBulk(statusData) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Contact',
          ids: this.selectedContacts,
          fields: statusData,
        });
        this.selectedContacts = [];
        this.showAlert(this.$t('BULK_ACTION.CONTACT_STATUS.UPDATE_SUCCESFUL'));
        // Refresh contacts after bulk action
        this.refreshContactsAfterBulkAction();
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.CONTACT_STATUS.UPDATE_FAILED'));
      }
    },
    refreshContactsAfterBulkAction() {
      // Short delay to allow backend to process
      setTimeout(() => {
        const currentPage = this.pageParameter;
        if (this.segmentsId !== 0 && this.activeSegment) {
          const payload = this.activeSegment.query;
          this.fetchSavedFilteredContact(payload, currentPage, this.searchQuery);
        } else if (this.hasAppliedFilters) {
          this.$store.dispatch('contacts/filter', {
            queryPayload: filterQueryGenerator(this.getAppliedContactFilters),
            page: currentPage,
            sortAttr: this.getSortAttribute(),
          });
        } else {
          this.fetchContacts(currentPage);
        }
      }, 500);
    },
  },
};
</script>
<style scoped>
.modal-overlay-v1 {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 39;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}

/*
 * Contacts table uses z-index up to 9999 for in-cell edit UIs (see ContactsTableVueTables2).
 * Default woot-modal `.modal-mask` is z-index 34, so the segment / advanced-filters modal can
 * render underneath the table on some viewports. Lift only this modal host (no global CSS).
 */
.contacts-advanced-filters-modal-host ::v-deep .modal-mask {
  z-index: var(--z-modal-mask, 10100);
}
</style>